import {call, put, select, takeEvery, takeLatest} from "redux-saga/effects";
import * as actions from "../action.constants";
import {
  storeDashboardCellsData,
  storeDashboards,
  storeWidgets,
} from "../Actions/tsdb.actions";
import {
  deleteDashboardAsync,
  getWidgetsAsync,
  requestDashboardCellsDataAsync,
  requestDashboardsAsync,
  updateDashboardAsync,
  createDashboardAsync,
  deleteDashboardCellAsync,
  handleSnapshotHandoffAsync,
  cloneSnapshotAsync,
  updateDashboardCellsBulkAsync,
} from "../AsyncActions/tsdb.async";

import {getCurrentCustomer} from "../Selectors/customers.selectors";
import {getSelectedController} from "../Selectors/controllers.selectors";
import {getDashboardCellsData as getCurrentDashboard} from "../Selectors/tsdb.selector";

function* getDashboards() {
  try {
    const response = yield call(requestDashboardsAsync);
    if (response?.data?.results) {
      yield put(storeDashboards(response.data.results));
    }
  } catch (e) {
    //
  }
}

function* getDashboardCellsData(action = {}) {
  const {payload} = action;

  try {
    const response = yield call(requestDashboardCellsDataAsync, {
      dashboard_id: payload,
    });
    if (response?.data?.data) {
      yield put(storeDashboardCellsData(response.data.data));
    }
  } catch (e) {
    //
  }
}

function* createDashboard(action = {}) {
  try {
    const {payload, callBack = () => {}, updateCallback = () => {}} = action;
    const selectedController = yield select(getSelectedController);
    const response = yield call(createDashboardAsync, {
      ...payload,
      controller_pk: selectedController?.mac,
    });
    if (response) {
      updateCallback();
      callBack();
    }
  } catch (_e) {
    //
  }
}

function* updateDashboard(action = {}) {
  try {
    const {payload, callBack = () => {}, updateCallback = () => {}} = action;
    const response = yield call(updateDashboardAsync, payload);
    if (response) {
      updateCallback();
      callBack();
    }
  } catch (_e) {
    //
  }
}

function* updateDashboardCells(action = {}) {
  try {
    const {payload} = action;
    yield call(updateDashboardCellsBulkAsync, payload);
  } catch (_e) {
    //
  }
}

function* deleteDashboard(action = {}) {
  try {
    const {payload, updateCallback = () => {}} = action;

    const response = yield call(deleteDashboardAsync, payload);
    if (response) {
      updateCallback();
    }
  } catch (e) {
    /* empty */
  }
}

function* deleteDashboardCell(action = {}) {
  try {
    const {payload, updateCallback = () => {}} = action;
    const currentDashboard = yield select(getCurrentDashboard);
    const response = yield call(deleteDashboardCellAsync, currentDashboard?.id, payload);
    if (response) {
      updateCallback();
    }
  } catch (e) {
    //
  }
}

function* getWidgets() {
  try {
    const currentCustomer = yield select(getCurrentCustomer);
    const response = yield call(getWidgetsAsync, {
      customerId: currentCustomer?.id,
    });

    if (response) {
      yield put(storeWidgets(response?.data));
    }
  } catch (e) {
    //
  }
}

function* handleSnapshotHandoff(action = {}) {
  const {payload = {}, callback = () => {}} = action;
  try {
    const response = yield call(handleSnapshotHandoffAsync, payload);
    if (response) {
      callback();
    }
  } catch (e) {
    return e;
  }
}

function* cloneSnapshot(action = {}) {
  const {payload, callback = () => {}} = action;
  try {
    const response = yield call(cloneSnapshotAsync, payload);
    if (response) {
      callback();
    }
  } catch (e) {
    return e;
  }
}

export function* tsdbSaga() {
  yield takeLatest(actions.REQUEST_DASHBOARDS, getDashboards);
  yield takeLatest(actions.REQUEST_DASHBOARD_CELLS_DATA, getDashboardCellsData);
  yield takeLatest(actions.CREATE_DASHBOARD, createDashboard);
  yield takeLatest(actions.UPDATE_DASHBOARD, updateDashboard);
  yield takeLatest(actions.DELETE_DASHBOARD, deleteDashboard);
  yield takeLatest(actions.DELETE_DASHBOARD_CELL, deleteDashboardCell);
  yield takeLatest(actions.UPDATE_CELLS, updateDashboardCells);
  yield takeLatest(actions.SNAPSHOT_CLONE, cloneSnapshot);
  yield takeEvery(actions.REQUEST_WIDGETS, getWidgets);
  yield takeEvery(actions.SNAPSHOT_HANDOFF, handleSnapshotHandoff);
}
